export const SITE = {
  name: "Sober Life Foundation",
  location: "Ulhasnagar",
  trust: "A Recovery Initiative by Balkan Ji Bari Trust",
  logo: "https://customer-assets-v7afamib.emergentagent.net/job_ace99f6b-8847-472d-82bf-a722f5d8ac86/artifacts/nirzy277_soberlogo.png",
  phone: "075591 85591",
  phoneHref: "+917559185591",
  email: "soberlifefoundation23@gmail.com",
  address: {
    lines: [
      "Bal Bhavan, Children's Hill Garden,",
      "Balkan Ji Bari Road, Ajad Nagar,",
      "Press Bazar, Ulhasnagar",
    ],
    full: "Bal Bhavan, Children's Hill Garden, Balkan Ji Bari Road, Ajad Nagar, Press Bazar, Ulhasnagar",
  },
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Gallery", to: "/gallery" },
  { label: "Contact", to: "/contact" },
];

export const HERO = {
  overline: "Men & Women Rehabilitation Centre",
  lines: ["A New Dawn", "Awaits You"],
  subtitle:
    "Helping individuals overcome addiction with professional care, compassion, and dignity. Recover. Rebuild. Rediscover life.",
};

export const SLOGANS = [
  "Hope Starts Here",
  "Recovery Begins Today",
  "Choose Recovery. Choose Life",
  "Every Life Deserves a Second Chance",
  "Together We Heal. Together We Rise",
  "Healing Beyond Addiction",
  "There Is Hope Beyond Addiction",
];

export const INTRO = {
  overline: "Who We Are",
  heading: "Compassionate care for lasting recovery",
  body: [
    "Sober Life Foundation is a dedicated rehabilitation and de-addiction centre committed to helping individuals break free from substance abuse and reclaim their lives. Operated under the esteemed Balkan Ji Bari Trust, our centre provides comprehensive rehabilitation services for both men and women in a safe, structured, and supportive environment.",
    "We understand that addiction affects not only the individual but also families, relationships, careers, and overall well-being. Our holistic recovery programs address the physical, emotional, psychological, and social aspects of addiction.",
  ],
};

export const PROGRAMS = [
  {
    tag: "01",
    title: "Men's Rehabilitation",
    desc: "A structured, disciplined and supportive environment designed for men, combining medical detox, counselling, fitness and life-skills to rebuild strength and purpose.",
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_sobriety-journey-19/artifacts/xhalz49o_8.webp",
  },
  {
    tag: "02",
    title: "Women's Rehabilitation",
    desc: "A safe, private and nurturing space for women, offering compassionate therapy, wellness activities and emotional healing tailored to their journey.",
    image:
      "https://images.unsplash.com/photo-1602192509154-0b900ee1f851?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
];

export const FEATURES = [
  "Professional Care Team",
  "Programs for Men & Women",
  "Personalized Recovery Plans",
  "Individual & Group Counselling",
  "Family Counselling",
  "Safe & Secure Environment",
  "Relapse Prevention Programs",
  "Confidential Treatment",
  "Long-Term Recovery Guidance",
];

export const PROCESS = [
  "Assessment",
  "Personalized Treatment",
  "Therapy & Counselling",
  "Healing & Growth",
  "Reintegration",
  "Lifelong Support",
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Our Mission",
    body: "To provide compassionate, evidence-based rehabilitation services that empower individuals struggling with addiction to achieve lasting recovery, restore self-worth, strengthen family relationships, and reintegrate confidently into society through personalized care and professional guidance.",
  },
  {
    no: "02",
    title: "Our Vision",
    body: "To become one of India's most trusted rehabilitation centres by transforming lives through compassionate care, ethical practices, holistic healing, and community support, ensuring every person battling addiction has access to quality rehabilitation and hope.",
  },
  {
    no: "03",
    title: "Our Core Values",
    body: "Compassion · Integrity · Recovery · Dignity · Excellence · Hope. These values guide every interaction, every treatment plan, and every step we take alongside those we serve.",
  },
  {
    no: "04",
    title: "Our Promise",
    body: "We don't just help people overcome addiction, we help them rediscover hope, rebuild relationships, and create a brighter future. Every individual is welcomed with compassion, treated with dignity, and supported throughout their recovery journey.",
  },
];

export const WHY = [
  {
    title: "Empathetic Care",
    body: "Experienced counsellors, therapists and medical professionals provide personalized, judgement-free support.",
  },
  {
    title: "Specialised Facilities",
    body: "Separate, safe and secure environments for men and women, designed for comfort and healing.",
  },
  {
    title: "Trusted Legacy",
    body: "A recovery initiative of the esteemed Balkan Ji Bari Trust, built on ethics, dignity and community.",
  },
];

const CDN = "https://customer-assets-jt897jd0.emergentagent.net/job_sobriety-journey-19/artifacts";

export const FACILITY = [
  { src: `${CDN}/3pv4ljr4_7.webp`, title: "Our Centre in Ulhasnagar", caption: "Separate wings for Gents & Ladies — Alcohol & Drugs Rehab Centre" },
  { src: `${CDN}/xhalz49o_8.webp`, title: "Fitness & Wellness", caption: "Guided physical activity and gym sessions as part of holistic recovery" },
  { src: `${CDN}/mlojamyx_5.webp`, title: "Comfortable Rooms", caption: "Clean, private and restful resident rooms with entertainment" },
  { src: `${CDN}/1xv09ivo_6.webp`, title: "Restful Accommodation", caption: "Well-maintained beds in a calm, supervised environment" },
  { src: `${CDN}/4xa2q60w_4.webp`, title: "Safe & Secure", caption: "24/7 CCTV-monitored premises for the safety of every resident" },
];

export const TESTIMONIALS = [
  {
    name: "Prateek Chhabda",
    text: "Sober Life Foundation provides affordable services for those seeking help with addiction. The staff is supportive and understanding. I found their programs to be reasonably priced and effective in helping me stay sober.",
    tag: "Reasonably priced",
  },
  {
    name: "Naresh Gangwani",
    text: "Sober Life Foundation provides excellent customer service. The staff is friendly and helpful. I was impressed by their willingness to answer all my questions and provide support. Highly recommend!",
    tag: "Great customer service",
  },
  {
    name: "Dhiraj",
    text: "A very nice rehab. They take great care of the patients and the staff is very well co-operated. Effective treatment, safe practices and good facilities.",
    tag: "Effective treatment",
  },
  {
    name: "Palak",
    text: "Sober Life Foundation has excellent customer service. The staff are always friendly and helpful, making me feel supported on my journey to sobriety.",
    tag: "Supportive staff",
  },
  {
    name: "Dinesh",
    text: "Good treatment with low cost. Attentive staff, well-sanitised and good facilities. Truly a place that helps you recover with dignity.",
    tag: "Good facilities",
  },
  {
    name: "Pal Alok",
    text: "One of the best de-addiction centres in Mumbai. Genuinely caring people who treat every resident with respect.",
    tag: "Highly recommended",
  },
];

export const REVIEW_STATS = { rating: "5.0", count: "233", source: "verified Google & JustDial reviews" };

export const GALLERY = [
  { src: `${CDN}/3pv4ljr4_7.webp`, alt: "Sober Life Foundation centre — Gents & Ladies rehab", span: "wide" },
  { src: `${CDN}/xhalz49o_8.webp`, alt: "Fitness and wellness sessions", span: "tall" },
  { src: `${CDN}/mlojamyx_5.webp`, alt: "Comfortable resident room with TV", span: "" },
  { src: `${CDN}/1xv09ivo_6.webp`, alt: "Restful accommodation", span: "" },
  { src: `${CDN}/4xa2q60w_4.webp`, alt: "24/7 CCTV-monitored secure premises", span: "tall" },
  { src: "https://images.unsplash.com/photo-1771868536783-ce35d0da644c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", alt: "Sunrise over calm water", span: "wide" },
  { src: "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", alt: "Hands together in support", span: "" },
  { src: "https://images.unsplash.com/photo-1602192509154-0b900ee1f851?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", alt: "Meditation and wellness", span: "" },
];
